import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  PROFILE_SELF_CONCEPTS,
} from '../../../constants';


class ProfilesSinglePersonality extends Component {

  render() {
    return (
      this.props.personality !== undefined && (
        <div className="row fullwidth">
          <div className="row demographic-detail-columns fullwidth">
            {/* <div className="large-2 medium-2 small-2 columns"><span>&nbsp;</span></div> */}
            <div className="large-12 medium-12 small-12 columns">
              <div
                className="profile-attitude-statement"
                title={this.props.personality[0][1].label}
              >
                <p className="profile-single-persona-header-block">
                  {this.props.personality[0][1].label}
                </p>
              </div>
            </div>
            {<div className="large-2 medium-2 small-2 columns"><span>&nbsp;</span></div>}
          </div>
          <div className="div-overflow">
            <div
              className="attitude-triple-comparision-metrics profile-personality-statement-matrix"
              id="profile-single-index-pdf"
            >
              INDEX:&nbsp;&nbsp;{this.props.personality[0][1].value.index}{' '}
              | REACH:&nbsp;&nbsp;{this.props.personality[0][1].value.pct}{' '}
            </div>
          </div>
          <div className="row demographic-detail-columns fullwidth">
            <div className="large-1 medium-1 small-1 columns">
              <span>&nbsp;</span>
            </div>
            <div className="large-10 medium-10 small-10 columns">
              {this.props.personality[1][0] === PROFILE_SELF_CONCEPTS &&
              <div
                className="profile-self-concepts"
                title={this.props.personality[1][1].label}
              >
                <p className="single-person-profile-self-concepts">
                  {this.props.personality[1][1].label}
                </p>
              </div>
            }
            </div>
            <div className="large-1 medium-1 small-1 columns">
              <span>&nbsp;</span>
            </div>
          </div>
        </div>
      )
    );
  }
}

ProfilesSinglePersonality.propTypes = {
  personality: PropTypes.instanceOf(Array),
};

export default connect(
  null,
  null,
  null,
  { forwardRef: true },
)(ProfilesSinglePersonality);
